const routes = [
    {
        path: "/event/request",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            // permission: "certificateapplication_index"
        }
    },

];

export default routes;
